export const translations = {
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      projects: 'Projects',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'Your vision, our creation.',
      subtitle: 'Build and transform your ideas with us. In Fourtech everything is possible.',
      cta: 'Discover Our Solutions'
    },
    about: {
      title: 'Our Journey',
      subtitle: 'About Fourtech',
      description: 'Founded in 2023 by a group of passionate university students, 4Tech began as team building academic projects that quickly evolved into something much bigger. What started with university assignments soon transformed into professional solutions for real-world challenges. Our journey from classroom projects to industry-leading solutions represents our commitment to innovation and excellence in technology.',
      stats: {
        years: 'Years',
        satisfaction: 'Satisfaction'
      }
    },
    projects: {
      title: 'Access our projects',
      githubTitle: 'Project Code',
      githubButton: 'View on GitHub',
      description: 'Explore our GitHub repository to access the source code of all our projects. Here you will find practical examples, detailed documentation, and the opportunity to collaborate with our team.'
    },
    services: {
      title: 'Our Team Skills',
      skills: {
        agile: {
          title: 'Agile Methodologies',
          description: 'Scrum framework with Sprint management, Planning, Daily Standups, Demo, and Feedback sessions to optimize project development.'
        },
        analysis: {
          title: 'Functional Analysis',
          description: 'Experts in analysis and design of technological solutions adapted to the specific needs of each client.'
        },
        development: {
          title: 'Development',
          description: 'Full-stack and software development with experience in React, Node.js, Django, and Spring Boot. We create robust and scalable web solutions and applications.'
        },
        data: {
          title: 'Data Analysis',
          description: 'Advanced data processing and analysis using Python and BI tools to obtain valuable insights.'
        },
        testing: {
          title: 'Testing',
          description: 'Automated and manual testing with Selenium, Jira, TFS, and agile methodologies to ensure quality.'
        },
        design: {
          title: 'UX/UI Design',
          description: 'Creation of intuitive and attractive interfaces using Figma, following the latest trends in design and user experience to bring our clients\' systems to life.'
        },
        security: {
          title: 'Cybersecurity',
          description: 'Implementation of robust security solutions and vulnerability audits to protect digital assets.'
        },
        database: {
          title: 'Database',
          description: 'Expert management of SQL databases, including MySQL for efficient data handling.'
        },
        languages: {
          title: 'Programming Languages',
          description: 'Experience in JavaScript, TypeScript, Python, Java, and other modern programming languages.'
        }
      }
    },
    contact: {
      title: 'Get in Touch',
      form: {
        name: 'Your Name',
        email: 'Your Email',
        message: 'Your Message',
        submit: 'Send Message'
      }
    },
    footer: {
      description: 'Pioneering the future of technology through innovation and excellence.',
      quickLinks: {
        title: 'Quick Links',
        about: 'About Us',
        services: 'Services',
        projects: 'Projects',
        contact: 'Contact'
      },
      services: {
        title: 'Services',
        robotics: 'Robotics',
        automation: 'Automation',
        ai: 'AI Solutions',
        consulting: 'Consulting'
      },
      newsletter: {
        title: 'Newsletter',
        placeholder: 'Your email',
        button: 'Subscribe'
      },
      copyright: ' 2025 4Tech. All rights reserved.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      about: 'Nosotros',
      projects: 'Proyectos',
      services: 'Servicios',
      contact: 'Contacto'
    },
    hero: {
      title: 'Tu visión, nuestra creación.',
      subtitle: 'Construye y transforma tus ideas con nosotros. En Fourtech todo es posible.',
      cta: 'Descubre Nuestras Soluciones'
    },
    about: {
      title: 'Nuestra Trayectoria',
      subtitle: 'Sobre Fourtech',
      description: 'Fundada en 2023 por un grupo de estudiantes universitarios apasionados, 4Tech comenzó construyendo proyectos académicos que rápidamente evolucionaron en algo mucho más grande. Lo que comenzó con trabajos universitarios pronto se transformó en soluciones profesionales para desafíos del mundo real. Nuestro viaje desde proyectos de clase hasta soluciones líderes en la industria representa nuestro compromiso con la innovación y la excelencia en tecnología.',
      stats: {
        years: 'Años',
        satisfaction: 'Satisfacción'
      }
    },
    projects: {
      title: 'Accede a nuestros proyectos',
      githubTitle: 'Código de Proyectos',
      githubButton: 'Ver en GitHub',
      description: 'Explora nuestro repositorio de GitHub para acceder al código fuente de todos nuestros proyectos. Aquí encontrarás ejemplos prácticos, documentación detallada y la oportunidad de colaborar con nuestro equipo.'
    },
    services: {
      title: 'Habilidades de nuestro equipo',
      skills: {
        agile: {
          title: 'Metodologías Ágiles',
          description: 'Marco de trabajo Scrum con gestión de Sprints, Planning, Daily Standups, Demo y sesiones de Retroalimentación para optimizar el desarrollo de proyectos.'
        },
        analysis: {
          title: 'Análisis Funcional',
          description: 'Expertos en análisis y diseño de soluciones tecnológicas adaptadas a las necesidades específicas de cada cliente.'
        },
        development: {
          title: 'Desarrollo',
          description: 'Desarrollo full-stack y software con experiencia en React, Node.js, Django y Spring Boot. Creamos soluciones web y aplicaciones robustas y escalables.'
        },
        data: {
          title: 'Análisis de Datos',
          description: 'Procesamiento y análisis avanzado de datos utilizando Python y herramientas de BI para obtener insights valiosos.'
        },
        testing: {
          title: 'Testing',
          description: 'Testing automatizado y manual con Selenium, Jira, TFS y metodologías ágiles para garantizar calidad.'
        },
        design: {
          title: 'Diseño UX/UI',
          description: 'Creación de interfaces intuitivas y atractivas usando Figma, siguiendo las últimas tendencias en diseño y experiencia de usuario para dar vida a los sistemas de nuestros clientes.'
        },
        security: {
          title: 'Ciberseguridad',
          description: 'Implementación de soluciones de seguridad robustas y auditorías de vulnerabilidades para proteger activos digitales.'
        },
        database: {
          title: 'Base de Datos',
          description: 'Gestión experta de bases de datos SQL, incluyendo MySQL para el manejo eficiente de datos.'
        },
        languages: {
          title: 'Lenguajes Dominados',
          description: 'Experiencia en JavaScript, TypeScript, Python, Java y otros lenguajes modernos de programación.'
        }
      }
    },
    contact: {
      title: 'Contáctanos',
      form: {
        name: 'Tu Nombre',
        email: 'Tu Email',
        message: 'Tu Mensaje',
        submit: 'Enviar Mensaje'
      }
    },
    footer: {
      description: 'Pioneros en el futuro de la tecnología a través de la innovación y la excelencia.',
      quickLinks: {
        title: 'Enlaces Rápidos',
        about: 'Sobre Nosotros',
        services: 'Servicios',
        projects: 'Proyectos',
        contact: 'Contacto'
      },
      services: {
        title: 'Servicios',
        robotics: 'Robótica',
        automation: 'Automatización',
        ai: 'Soluciones IA',
        consulting: 'Consultoría'
      },
      newsletter: {
        title: 'Boletín',
        placeholder: 'Tu email',
        button: 'Suscribirse'
      },
      copyright: ' 2025 4Tech. Todos los derechos reservados.'
    }
  }
};
